/** OS-1716 — presentación de los módulos de un tenant (los datos y las reglas vienen del API). */

const DATE_TIME = new Intl.DateTimeFormat('es-CO', {
  day: 'numeric',
  month: 'short',
  year: 'numeric',
  hour: '2-digit',
  minute: '2-digit',
});

const DATE = new Intl.DateTimeFormat('es-CO', { day: 'numeric', month: 'short', year: 'numeric' });

export function formatDateTime(iso: string): string {
  return DATE_TIME.format(new Date(iso));
}

export function formatDate(iso: string): string {
  return DATE.format(new Date(iso));
}

/** Nombre visible de una lista de claves de módulo, según el catálogo que devolvió el API. */
export function moduleNames(keys: readonly string[], names: ReadonlyMap<string, string>): string {
  return keys.map((key) => names.get(key) ?? key).join(', ');
}

/** Origen de la habilitación (`source` del API). */
export function sourceLabel(
  source: string | null,
  presetNames: ReadonlyMap<string, string>,
): string | null {
  if (!source) {
    return null;
  }
  if (source.startsWith('preset:')) {
    const key = source.slice('preset:'.length);
    return `Preset ${presetNames.get(key) ?? key}`;
  }
  if (source.startsWith('backfill:')) {
    return 'Migración inicial';
  }
  return source === 'bootstrap' ? 'Alta del tenant' : source === 'manual' ? 'Cambio manual' : source;
}

export function plural(count: number, one: string, many: string): string {
  return `${count} ${count === 1 ? one : many}`;
}
